import React from 'react';
import PropTypes from 'prop-types';
import '../index.css';

function SkintoneImg(props) {
  return (
    <img onClick={ () => props.onModelSelected(props.value) } value={ props.value } className={`img-fluid img-skintone ${ props.value }`} src={ props.src } />
  );
}

SkintoneImg.propTypes = {
    src: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onModelSelected: PropTypes.func.isRequired
};

export default SkintoneImg;